import { render } from "./primera_foto.vue?vue&type=template&id=dd7a2bb8&scoped=true"
import script from "./primera_foto.vue?vue&type=script&lang=js"
export * from "./primera_foto.vue?vue&type=script&lang=js"

import "./primera_foto.vue?vue&type=style&index=0&id=dd7a2bb8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dd7a2bb8"]])

export default __exports__